<script setup lang="ts">
import {computed} from "vue";
import {formatThousands} from "@/helpers/string";

const {report} = defineProps(['report']);

const data = computed(() => JSON.parse(report.report_data));
</script>

<template>
    <div class="report-container">
        <div class="report-container__col">
            <div style="padding: 30px">
                <h2 class="report-container__title">
                    {{ report.tracker_name }}
                </h2>

                <template v-if="data && 'trends' in data">
                    <div>Several key trends are shaping this market:</div>

                    <ol>
                        <li v-for="(trend, index) in data.trends" :key="index">
                            <span>{{ trend }}</span>
                        </li>
                    </ol>
                </template>
            </div>
        </div>

        <div class="report-container__col">
            <div>
                <div class="cell left dark">
                    <div class="up">
                        {{report.startups_count}}
                    </div>

                    <div class="down">
                        Startups analyzed
                    </div>
                </div>

                <div class="cell right light">
                    <div class="up">
                        <template v-if="data?.market_opportunity">
                            ${{formatThousands(data.market_opportunity)}}
                        </template>
                    </div>

                    <div class="down">
                        Market opportunity
                    </div>
                </div>
            </div>

            <div>
                <div class="cell left light">

                </div>

                <div class="cell right dark">

                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .report-container {
        font-size: 20px;

        @media (min-width: 1024px) {
            display: flex;
        }
        @media (min-width: 1200px) {
            width: 1100px;

            .report-container__col {
                width: 55%;

                &:last-child {
                    width: 45%;
                }
            }
        }
        .report-container__title {
            margin-bottom: 30px; 
            font-weight: bold;
            font-size: 20px;

            @media (min-width: 1024px) {
                font-size: 50px;
            }
        }
        ol {
            margin-top: 10px;
            padding-left: 30px;
        }
        li {
            margin-bottom: 10px;
            font-weight: bold;
        }
        li span {
            font-weight: normal;
        }
        .cell {
            width: 50%;
            height: 231px;
            text-align: center;
        }
        .left {
            float: left;
        }
        .right {
            float: right;
        }
        .dark {
            background-color: #c4d8e1;
        }
        .light {
            background-color: #f3f4f6;
        }
        .up {
            padding-top: 70px;
            padding-bottom: 20px;
            font-weight: bold;
            font-size: 50px;
        }
    }
</style>
